import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"position":"relative"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 mb-1" }, "Create a card", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "byline" }, "You don't have any cards yet. Please click the button below to create your first card.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "button is-link mt-4" }, "Create card", -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_card_create_update = _resolveComponent("card-create-update")!
  const _component_card_read = _resolveComponent("card-read")!

  return (_openBlock(), _createBlock(_Transition, {
    mode: "out-in",
    name: "fade"
  }, {
    default: _withCtx(() => [
      (!_ctx.getCardIsFilledState && _ctx.loadingData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_loader)
          ]))
        : (_ctx.getCardIsFilledState || _ctx.creatingCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_Transition, {
                mode: "out-in",
                onLeave: _ctx.onLeave,
                onBeforeEnter: _ctx.onBeforeEnter,
                onEnter: _ctx.onEnter
              }, {
                default: _withCtx(() => [
                  (_ctx.cardState === 'CardCreateUpdate')
                    ? (_openBlock(), _createBlock(_component_card_create_update, {
                        key: 0,
                        creatingCard: _ctx.creatingCard,
                        cardData: _ctx.getCardData,
                        onCancelCardDataUpdate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cardState = 'CardRead')),
                        onCardDataSubmittedToServer: _cache[1] || (_cache[1] = ($event: any) => {_ctx.cardState = 'CardRead'; _ctx.creatingCard = false;})
                      }, null, 8, ["creatingCard", "cardData"]))
                    : (_ctx.cardState === 'CardRead')
                      ? (_openBlock(), _createBlock(_component_card_read, {
                          key: 1,
                          cardData: _ctx.getCardData,
                          cardKey: _ctx.getCardKey,
                          onEditCardData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cardState = 'CardCreateUpdate'))
                        }, null, 8, ["cardData", "cardKey"]))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onLeave", "onBeforeEnter", "onEnter"])
            ]))
          : (!_ctx.getCardIsFilledState && !_ctx.loadingData)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "card card--empty",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.creatingCard = true; _ctx.cardState = 'CardCreateUpdate'})
              }, _hoisted_6))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}